//live test server on digitalocean
export const ROOT_URL = "https://test-live.datadashbd.com/api";
// php artisan serve --host=192.168.10.133  --port=8000 for my local ip
// php artisan serve --host=192.168.10.30  --port=8000 for my local ip
//live server
// export const ROOT_URL = "https://app.datadashbd.com/api";

//local server Rockey
// export const ROOT_URL = "http://datadash-backend.test/api";

export default {
  rootUrl: ROOT_URL,
};
